import { render } from "./reset-password.vue?vue&type=template&id=1f740bb8"
import script from "./reset-password.vue?vue&type=script&lang=js"
export * from "./reset-password.vue?vue&type=script&lang=js"

import "./reset-password.vue?vue&type=style&index=0&id=1f740bb8&lang=css"
script.render = render

export default script